const languageDateFormatMap = {
  "fa": "jYYYY/jMM/jDD",
  "en": "MM/DD/YYYY",
  "ar": "iYYYY/iMM/iDD"
}

export default languageDateFormatMap